import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzTypographyModule } from 'ng-zorro-antd/typography';

import { TranslationLookupModule } from '@main-client/src/app/pipes/translation-lookup/translation-lookup.module';

import { ProgramChartGaugeComponent } from './program-chart-gauge/program-chart-gauge.component';
import { ProgramHealthChartComponent } from './program-health-chart/program-health-chart.component';
import { ProgramMatchesChartComponent } from './program-matches-chart/program-matches-chart.component';
import { ProgramParticipantsChartComponent } from './program-participants-chart/program-participants-chart.component';
import { ProgramParticipationChartComponent } from './program-participation-chart/program-participation-chart.component';
import { CountUpPipe } from '@libs/src/count-up-pipe/count-up.pipe';

@NgModule({
  declarations: [
    ProgramHealthChartComponent,
    ProgramMatchesChartComponent,
    ProgramParticipationChartComponent,
    ProgramParticipantsChartComponent,
    ProgramChartGaugeComponent,
  ],
  exports: [
    ProgramChartGaugeComponent,
    ProgramParticipantsChartComponent,
    ProgramMatchesChartComponent,
    ProgramHealthChartComponent,
    ProgramParticipationChartComponent,
  ],
  imports: [
    CommonModule,
    CountUpPipe,
    FlexLayoutModule,
    MatIconModule,
    NzBadgeModule,
    NzProgressModule,
    NzSelectModule,
    NzSkeletonModule,
    NzToolTipModule,
    NzTypographyModule,
    ReactiveFormsModule,
    TranslationLookupModule,
  ],
})
export class ProgramOverviewChartsModule {}
